import { Badge, Descriptions } from 'antd';
import React from 'react';
import moment from 'moment'

const Description = ({info}) => (
  <Descriptions title="Info" layout="vertical" bordered>
    {
      Object.entries(info).map(([key, value]) => {
        if(key === 'created_by') {
          return (
            <Descriptions.Item key={key} label='สร้างโดย'>
              {`type: ${value.type}`}
              <br />
              {`id: ${value.id}`}
              <br />
              {`email: ${value.email}`}
            </Descriptions.Item>
          )
        }

        if (key === 'read') {
          return (
            <Descriptions.Item key={key} label='อ่านเมื่อ'>
              {value ? moment(value).format('DD-MM-YYYY HH:mm') : false}
            </Descriptions.Item>
          )
        }

        if (key === 'line_notification_cron_id') {
          return (
            <Descriptions.Item key={key} label={key}>
              <a href={`/admins/notifications/line_crons/${value}/edit`} target="_blank" rel="noreferrer">{value}</a>
            </Descriptions.Item>
          )
        }

        return (<Descriptions.Item key={key} label={key}>{value}</Descriptions.Item>)
      })
    }

  </Descriptions>
);
export default Description;
